if (!customElements.get('bloomair-hero-slideshow')) {
  class BloomAirHeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.slides = this.querySelectorAll('.bloomair-hero-slideshow__slide');
      this.dots = this.querySelectorAll('.bloomair-hero-slideshow__dot');
      this.prevBtn = this.querySelector('.bloomair-hero-slideshow__arrow--prev');
      this.nextBtn = this.querySelector('.bloomair-hero-slideshow__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.currentIndex = 0;
      this.interval = null;
      this.totalSlides = this.slides.length;

      if (this.totalSlides <= 1) return;

      this.init();
    }

    init() {
      this.prevBtn.addEventListener('click', () => this.goToPrev());
      this.nextBtn.addEventListener('click', () => this.goToNext());

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.slideTo, 10);
          this.goTo(index);
        });
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('touchstart', () => this.pause(), { passive: true });
      this.addEventListener('touchend', () => this.resume());

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    goTo(index) {
      if (index === this.currentIndex) return;
      if (index < 0) index = this.totalSlides - 1;
      if (index >= this.totalSlides) index = 0;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex].classList.remove('is-active');

      this.slides[index].classList.add('is-active');
      this.dots[index].classList.add('is-active');

      this.currentIndex = index;
    }

    goToNext() {
      this.goTo(this.currentIndex + 1);
      if (this.autoplay) this.resetAutoplay();
    }

    goToPrev() {
      this.goTo(this.currentIndex - 1);
      if (this.autoplay) this.resetAutoplay();
    }

    startAutoplay() {
      this.interval = setInterval(() => {
        this.goToNext();
      }, this.speed);
    }

    resetAutoplay() {
      if (!this.autoplay) return;
      clearInterval(this.interval);
      this.startAutoplay();
    }

    pause() {
      clearInterval(this.interval);
    }

    resume() {
      if (!this.autoplay) return;
      this.startAutoplay();
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('bloomair-hero-slideshow', BloomAirHeroSlideshow);
}
